import React, { useState } from 'react';
import styled from 'styled-components';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const months = [
  "Jan-31", "Feb-28", "Mar-31", "Apr-30", "May-31", "Jun-30",
  "Jul-30", "Aug-30", "Sept-30", "Oct-30", "Nov-30", "Dec-30"
];

const initialPrograms = [
  { program: "EPAHP", indicators: ["No. of Marketing Agreements", "Gross Sales (Php)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "PCB Project - SLP", indicators: ["No. of Projects", "No. of Beneficiaries (IA Members)", "Gross Sales (Php)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "Cash for Work", indicators: ["No. of Beneficiaries (IA Members)", "Cash Counterpart (Php)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "Walang Gutom Program", indicators: ["No. of IA", "No. of Beneficiaries (IA Members)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "Family Food Packs", indicators: ["No. of IA", "No. of Beneficiaries (IA Members)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "Food for Work", indicators: ["No. of IA", "No. of Beneficiaries (IA Members)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "Gulayan sa Pamayanan", indicators: ["No. of Beneficiaries (IA Members)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "LAWA at BINHI", indicators: ["No. of IA", "IA Members"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "Financial Assistance", indicators: ["No. of Beneficiaries (IA Members)", "Area(ha)", "Cash Counterpart (Php)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "Trainings", indicators: ["No. of Trainings", "No. of IA", "No. of Batches", "No. of Farmers trained (IA Members)"], department: "Department of Social Welfare and Development (DSWD)" },
  { program: "Job Creation", indicators: ["No. of Jobs Created", "No. of Beneficiaries"], department: "Department of Labor and Employment (DOLE)" },
  { program: "Skills Training", indicators: ["No. of Training Sessions", "No. of Participants"], department: "Department of Labor and Employment (DOLE)" }
];

function ConvergenceTemplate() {
  const [editableMonths, setEditableMonths] = useState(months);
  const [programData, setProgramData] = useState(
    initialPrograms.map(p => ({
      program: p.program,
      department: p.department,
      data: p.indicators.map(ind => ({
        indicator: ind,
        status2024: '',
        target2025: '',
        months: months.map(() => ''),
        total: '',
        statusToDate: '',
        remarks: '',
      })),
    }))
  );

  const headers = [
    'PROGRAM',
    'INDICATOR',
    '2024 STATUS',
    '2025 TARGET',
    ...editableMonths,
    'TOTAL',
    'STATUS TO DATE',
    'REMARKS'
  ];

  const handleInput = (pIdx, iIdx, field, mIdx, value) => {
    setProgramData(prev => {
      const next = [...prev];
      const entry = next[pIdx].data[iIdx];
      if (field === 'months') {
        entry.months[mIdx] = value;
      } else {
        entry[field] = value;
      }
      return next;
    });
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.href = '/';
  };

const exportToExcel = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Convergence Template');

  // Title row
  worksheet.mergeCells('A1:Q1');
  worksheet.getCell('A1').value = 'CONVERGENCE PROGRAM MONITORING FORM - TEMPLATE';
  worksheet.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };
  worksheet.getCell('A1').font = { bold: true, size: 14 };

  // Instruction row
  worksheet.mergeCells('A2:Q2');
  worksheet.getCell('A2').value = 'Fill in the fields below before importing';
  worksheet.getCell('A2').alignment = { horizontal: 'center', vertical: 'middle' };

  // Header row
  const headers = [
    'PROGRAM',
    'INDICATOR',
    '2024 STATUS',
    '2025 TARGET',
    ...editableMonths,
    'TOTAL',
    'STATUS TO DATE',
    'REMARKS'
  ];
  const headerRow = worksheet.addRow(headers);
  headerRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: 'center' };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
    cell.border = {
      top: { style: 'thin' }, left: { style: 'thin' },
      bottom: { style: 'thin' }, right: { style: 'thin' }
    };
  });

  // Data rows
  programData.forEach(prog => {
    prog.data.forEach(entry => {
      const row = worksheet.addRow([
        prog.program,
        entry.indicator,
        entry.status2024,
        entry.target2025,
        ...entry.months,
        entry.total,
        entry.statusToDate,
        entry.remarks
      ]);
      row.eachCell(cell => {
        cell.border = {
          top: { style: 'thin' }, left: { style: 'thin' },
          bottom: { style: 'thin' }, right: { style: 'thin' }
        };
      });
    });
  });

  worksheet.columns.forEach(col => col.width = 18);

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
    `Convergence_Template_${new Date().toISOString().slice(0, 10)}.xlsx`
  );
};

  return (
    <Container>
      <TopControls>
        <BackButton onClick={handleBack}>Back</BackButton>
      </TopControls>
      <h2>CONVERGENCE PROGRAM MONITORING FORM</h2>
      <div style={{ marginBottom: '20px' }}>
        <p style={{ cursor: 'pointer', textDecoration: 'underline' }}>As of August 09, 2025</p>
      </div>
      <RegionTitle>Region 7</RegionTitle>
      <TableWrapper id="scrollContent">
        <StyledTable>
          <thead>
            <tr style={{ backgroundColor: '#2e7d32', color: 'white', position: 'sticky', top: 0 }}>
              <th rowSpan="2" style={tableCellStyle}>PROGRAM</th>
              <th rowSpan="2" style={tableCellStyle}>INDICATOR</th>
              <th rowSpan="2" style={tableCellStyle}>2024 STATUS</th>
              <th rowSpan="2" style={tableCellStyle}>2025 TARGET</th>
              <th colSpan={12} style={tableCellStyle}>C.Y 2025 ACCOMPLISHMENT</th>
              <th rowSpan="2" style={tableCellStyle}>TOTAL</th>
              <th rowSpan="2" style={tableCellStyle}>STATUS TO DATE</th>
              <th rowSpan="2" style={tableCellStyle}>REMARKS</th>
            </tr>
            <tr style={{ backgroundColor: '#3eaf27', color: 'white' }}>
              {editableMonths.map((month, i) => (
                <th key={i} style={monthCellStyle}>
                  <input
                    type="text"
                    value={month}
                    onChange={(e) => {
                      const newMonths = [...editableMonths];
                      newMonths[i] = e.target.value;
                      setEditableMonths(newMonths);
                    }}
                    style={{ width: '100%', border: 'none', background: 'transparent', color: 'white', fontWeight: 'bold', textAlign: 'center', fontSize: 14, cursor: 'text' }}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {programData.reduce((acc, prog, pIdx) => {
              const lastProgIdx = acc.findIndex(p => p.department === prog.department);
              if (lastProgIdx === -1) {
                acc.push({ ...prog, startIdx: pIdx });
              } else {
                acc[lastProgIdx].endIdx = pIdx + 1;
              }
              return acc;
            }, []).map((progGroup, groupIdx) => (
              <React.Fragment key={progGroup.department}>
                <tr style={{ backgroundColor: '#ffff00', fontWeight: 'bold' }}>
                  <td colSpan="20" style={{ ...tableCellStyle, textAlign: 'left', paddingLeft: '12px' }}>
                    ({progGroup.department})
                  </td>
                </tr>
                {programData.slice(progGroup.startIdx, progGroup.endIdx || programData.length).map((prog, pIdx) =>
                  prog.data.map((entry, iIdx) => (
                    <tr key={`${prog.program}-${iIdx}`}>
                      {iIdx === 0 && <td rowSpan={prog.data.length} style={tableCellStyle}>{prog.program}</td>}
                      <td style={tableCellStyle}>{entry.indicator}</td>
                      <td style={tableCellStyle}><Input value={entry.status2024} onChange={e => handleInput(progGroup.startIdx + pIdx, iIdx, 'status2024', null, e.target.value)} /></td>
                      <td style={tableCellStyle}><Input value={entry.target2025} onChange={e => handleInput(progGroup.startIdx + pIdx, iIdx, 'target2025', null, e.target.value)} /></td>
                      {entry.months.map((mv, mIdx) => (
                        <td key={mIdx} style={monthCellStyle}><Input value={mv} onChange={e => handleInput(progGroup.startIdx + pIdx, iIdx, 'months', mIdx, e.target.value)} /></td>
                      ))}
                      <td style={tableCellStyle}><Input value={entry.total} onChange={e => handleInput(progGroup.startIdx + pIdx, iIdx, 'total', null, e.target.value)} /></td>
                      <td style={tableCellStyle}><Input value={entry.statusToDate} onChange={e => handleInput(progGroup.startIdx + pIdx, iIdx, 'statusToDate', null, e.target.value)} /></td>
                      <td style={tableCellStyle}><Input value={entry.remarks} onChange={e => handleInput(progGroup.startIdx + pIdx, iIdx, 'remarks', null, e.target.value)} /></td>
                    </tr>
                  ))
                )}
              </React.Fragment>
            ))}
          </tbody>
        </StyledTable>
      </TableWrapper>
      <div id="bottomScroll" style={{ height: '20px', overflowX: 'auto', overflowY: 'hidden', width: '100%' }}>
        <div style={{ width: '1200px', height: '1px' }} />
      </div>
      <ExportButton onClick={exportToExcel}>📤 Export Template</ExportButton>
    </Container>
  );
}

export default ConvergenceTemplate;

// Styled Components
const Container = styled.div`
  padding: 20px;
  margin-top: 20px;
  max-width: 100%;
  overflow-x: auto;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 500px;
  border: 1px solid #ccc;
  width: 100%;
`;

const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  min-width: 1200px;
`;

const tableCellStyle = {
  border: '1px solid #ccc',
  padding: '8px',
  textAlign: 'center',
  fontSize: '14px',
};

const monthCellStyle = {
  ...tableCellStyle,
  width: '70px',
  minWidth: '70px',
  maxWidth: '80px',
  whiteSpace: 'nowrap',
};

const Input = styled.input`
  width: 100%;
  border: none;
  padding: 4px;
  box-sizing: border-box;
  font-size: 14px;
  background: transparent;
  text-align: center;
`;

const ExportButton = styled.button`
  margin: 0 2px;
  padding: 6px 10px;
  background-color: #2e7d32;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: #276a2b;
  }
`;

const RegionTitle = styled.h3`
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 20px;
  color: #353131ff;
`;

const TopControls = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
`;

const BackButton = styled.button`
  margin: 0 2px;
  padding: 6px 12px;
  background-color: #eeeeee;
  color: #222;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #e2e2e2;
  }
`;